module.exports = __webpack_public_path__ + "media/images/icon-card/icon-card-05-e6651637f7610d9bdec110b0273f8dd6.svg";